// extracted by mini-css-extract-plugin
export default {"multiSelectCrumbs":"X5-z"};